<template>
  <v-container fluid class="pa-4 rtl">
    <!-- Header -->
    <v-card class="header-card mb-4" elevation="2">
      <div class="d-flex align-center justify-space-between flex-wrap ga-3">
        <div>
          <div class="text-h5 font-weight-bold" style="color: #4a4f55">
            صحة الأم وحديثي الولادة والصحة الإنجابية
          </div>
          <div class="text-body-2 text-grey-darken-1 mt-1">
            MNH & SRH | حالة الخدمات وعوامل الخطر
          </div>
        </div>
        <v-btn
          prepend-icon="mdi-arrow-right"
          variant="text"
          style="color: #4a4f55"
          @click="showView('pillar-services')"
        >
          رجوع
        </v-btn>
      </div>
    </v-card>

    <!-- KPIs -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">1</div>
          <div class="kpi-label">مرفق SRH متوقف</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">42,000</div>
          <div class="kpi-label">امرأة بلا رعاية إنجابية</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">3/9</div>
          <div class="kpi-label">يقدمون ولادات آمنة</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">22</div>
          <div class="kpi-label">قابلة معتمدة (من أصل 60)</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-card class="table-card" elevation="1">
      <div class="table-header">حالة خدمات MNH و SRH</div>
      <v-table class="custom-table">
        <thead>
          <tr>
            <th>المرفق</th>
            <th>ولادة آمنة</th>
            <th>رعاية ما قبل الولادة</th>
            <th>رعاية ما بعد الولادة</th>
            <th>خدمات SRH</th>
            <th>GBV/PEP Kit</th>
            <th>قابلات متاحات</th>
            <th>حالة الخدمة</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in facilities" :key="item.name">
            <td class="font-weight-bold">{{ item.name }}</td>
            <td>
              <v-chip
                :color="chipColor(item.safeDelivery)"
                size="small"
                variant="flat"
                >{{ item.safeDelivery }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="chipColor(item.anc)"
                size="small"
                variant="flat"
                >{{ item.anc }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="chipColor(item.pnc)"
                size="small"
                variant="flat"
                >{{ item.pnc }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="chipColor(item.srh)"
                size="small"
                variant="flat"
                >{{ item.srh }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="chipColor(item.gbv)"
                size="small"
                variant="flat"
                >{{ item.gbv }}</v-chip
              >
            </td>
            <td class="font-weight-bold">{{ item.midwives }}</td>
            <td>
              <v-chip
                :color="chipColor(item.status)"
                size="small"
                variant="flat"
                >{{ item.status }}</v-chip
              >
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </v-container>
</template>

<script setup>
const facilities = [
  {
    name: "مستشفى الصداقة التعليمي",
    safeDelivery: "جزئي",
    anc: "كامل",
    pnc: "جزئي",
    srh: "جزئي",
    gbv: "لا يوجد",
    midwives: 8,
    status: "جزئي",
  },
  {
    name: "مستشفى الأمراض النفسية",
    safeDelivery: "جزئي",
    anc: "جزئي",
    pnc: "جزئي",
    srh: "متوقف",
    gbv: "لا يوجد",
    midwives: 2,
    status: "جزئي",
  },
  {
    name: "مجمع الشيخ عثمان",
    safeDelivery: "لا يوجد",
    anc: "جزئي",
    pnc: "جزئي",
    srh: "جزئي",
    gbv: "لا يوجد",
    midwives: 5,
    status: "جزئي",
  },
  {
    name: "مركز كود العثماني",
    safeDelivery: "كامل",
    anc: "كامل",
    pnc: "كامل",
    srh: "لا يوجد",
    gbv: "لا يوجد",
    midwives: 2,
    status: "كامل",
  },
  {
    name: "مركز الممدارة",
    safeDelivery: "كامل",
    anc: "كامل",
    pnc: "كامل",
    srh: "جزئي",
    gbv: "لا يوجد",
    midwives: 3,
    status: "كامل",
  },
  {
    name: "مركز المحاريق",
    safeDelivery: "لا يوجد",
    anc: "جزئي",
    pnc: "جزئي",
    srh: "جزئي",
    gbv: "لا يوجد",
    midwives: 1,
    status: "جزئي",
  },
  {
    name: "مركز عبد القوي",
    safeDelivery: "كامل",
    anc: "كامل",
    pnc: "كامل",
    srh: "جزئي",
    gbv: "لا يوجد",
    midwives: 2,
    status: "كامل",
  },
  {
    name: "مركز ماري ستبوس",
    safeDelivery: "متوقف",
    anc: "متوقف",
    pnc: "متوقف",
    srh: "متوقف",
    gbv: "لا يوجد",
    midwives: 0,
    status: "متوقف",
  },
  {
    name: "جمعية حقوق الطفل",
    safeDelivery: "لا يوجد",
    anc: "جزئي",
    pnc: "جزئي",
    srh: "لا يوجد",
    gbv: "لا يوجد",
    midwives: 1,
    status: "جزئي",
  },
];

const chipColor = (value) => {
  if (value === "كامل") return "green";
  if (value === "جزئي") return "orange";
  return "red";
};

const showView = (view) => {
  console.log("Go to:", view);
};
</script>

<style scoped>
.rtl {
  direction: rtl;
}

.header-card {
  border-right: 5px solid #4a4f55;
  border-radius: 18px;
  padding: 20px;
}

.kpi-card {
  border-radius: 18px;
  padding: 20px;
  text-align: center;
}

.kpi-value {
  font-size: 34px;
  font-weight: 800;
}

.kpi-label {
  margin-top: 6px;
  font-size: 13px;
}

.danger {
  background: #fdecea;
  color: #c0392b;
}

.warning {
  background: #fff4e5;
  color: #d4821a;
}

.table-card {
  border-radius: 18px;
  overflow: hidden;
}

.table-header {
  padding: 18px;
  font-size: 18px;
  font-weight: 700;
  color: #3a3f47;
  border-bottom: 1px solid #eee;
}

.custom-table {
  direction: rtl;
}

:deep(th) {
  font-weight: 800 !important;
  color: #3a3f47 !important;
  white-space: nowrap;
}

:deep(td) {
  font-size: 14px;
  white-space: nowrap;
}
</style>
